import React from 'react';
import { HotelAddEdit } from './HotelAddEdit';
import { HotelAddEditProps } from './HotelForm.types';
import { AdminAccommodationsTelemetryProvider } from '../../Accommodations.telemetry';

export const Hotel: React.FC<HotelAddEditProps> = props => {
  return (
    <AdminAccommodationsTelemetryProvider>
      <HotelAddEdit {...props} />
    </AdminAccommodationsTelemetryProvider>
  );
};
